import { Injectable } from '@angular/core';
import {Router, CanActivate, NavigationEnd} from '@angular/router';
import { AuthService } from './auth.service';
import {ConstantUtils} from '../utils/constant.utils';
@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(public auth: AuthService, public router: Router) { }
  canActivate(): boolean {
    const status = this.auth.isAuthenticated();


    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const currentPath = event.url;
        if (currentPath.startsWith('/enquiry')) {
          localStorage.setItem(ConstantUtils.SOURCE_FROM, ConstantUtils.ENQUIRY);
        } else {
          localStorage.setItem(ConstantUtils.SOURCE_FROM, ConstantUtils.ADMIN);
        }
        const ignoredUrls = ['/admin/login', '/super-admin/login', '/staff/email-login', '/enquiry/login', '/session-expired', '/unauthorized-access', '/privacy-policy', '/landing'];
        if (ignoredUrls.indexOf(currentPath) < 0) {
          console.log('Current Path ', currentPath);
        }
      }
    });

    if (status === 0) {
      this.router.navigate(['unauthorized-access']);
      return false;
    }

    if (status === 1) {
      return true;
    }

    if (status === 2) {
      this.router.navigate(['session-expired']);
      return false;
    }
  }
}
